import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import { Button } from 'components/form/Button/Button';
import Label from 'components/form/Label/Label';
import './OneClickApplicationModuleView.scss';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import OText from 'components/CText/OText';
import { Image } from 'components/Image/Image';
import { usePublicHeaderHook } from 'partial/Header/PublicHeader.hook';

const ApprovedView = props => {
  const {
    oneClickApplicationOffer,
    onClickGoToDashboard,
    approvalDecision,
    decisionMap,
  } = props;

  const decision = decisionMap[approvalDecision?.genericData?.status];
  const decisionSubtitle = decision?.subTitle
    ?.replace('[credit_limit]', approvalDecision?.genericData?.creditLine)
    .replace('[product_name]', oneClickApplicationOffer?.name);
  return (
    <FlexContainer className="approval-container justify-between padT60">
      <FlexContainer className="approvalTextContainer flex-column m-items-align-center m-text-center">
        <Label typeHeader={'h4'} className="H4">
          {decision?.title}
        </Label>
        <DecisionImage
          decision={decision}
          oneClickApplicationOffer={oneClickApplicationOffer}
          decisionImageClass="d-hide m-margT24"
        />
        <Label className="subtitleContainer margT20">
          <OText text={decisionSubtitle} />
        </Label>

        <Button
          name="submit"
          mrphType="primary"
          datatestid={`userReviewSubmit`}
          className="margT30 m-margT70 text-16 submitButton"
          key="submit"
          onClick={onClickGoToDashboard}
        >
          Return to Dashboard
        </Button>
      </FlexContainer>
      <DecisionImage
        decision={decision}
        oneClickApplicationOffer={oneClickApplicationOffer}
        decisionImageClass="m-hide"
      />
    </FlexContainer>
  );
};

const DecisionImage = props => {
  const { oneClickApplicationOffer, decisionImageClass, decision } = props;
  return (
    <FlexContainer className={decisionImageClass}>
      {decision?.showCardImage && (
        <FlexContainer className="m-flex-column m-items-align-center">
          <Image className={'d-hide approvalCheck'} />
          <img
            alt="credit card"
            src={`${oneClickApplicationOffer?.imageLink}`}
            className="imgApprovalCardSize m-margT16"
          />
        </FlexContainer>
      )}

      {!decision?.showCardImage && <Image className={decision?.imageIcon} />}
    </FlexContainer>
  );
};

const ApprovalDecisionModuleView = props => {
  const {
    oneClickApplicationOffer,
    approvalDecision,
    onClickGoToDashboard,
    decisionMap,
  } = props;
  // as this cant be changed ones is set for the first time in the main page , decision page is also executing this in order to change again the header.
  usePublicHeaderHook(true, 'OVERVIEW_BACK', true);
  return (
    <SectionContainer className="bgGrey005 m-bgWhite">
      <Row className="bgWhite">
        <ApprovedView
          oneClickApplicationOffer={oneClickApplicationOffer}
          onClickGoToDashboard={onClickGoToDashboard}
          approvalDecision={approvalDecision}
          decisionMap={decisionMap}
        />
      </Row>
    </SectionContainer>
  );
};

export default ApprovalDecisionModuleView;
